module.exports = __webpack_public_path__ + "static/media/featured_listing_1.34ddd465.png";